/*
 * Props:
 * - visible (bool): whether the popup is shown
 */

import { useEffect, useState } from "react";
import style from './index.module.scss'
import cn from 'classnames';

const Popup = ({
    visible = false,
    children,
    fullPopupView = false
}) => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        setIsVisible(visible)
    }, [visible])

    if (!isVisible) return null;

    return (
        <div className={cn("w-100 h-100 d-flex flex-column align-items-center justify-content-center", style.popupContainer)}>
            <div className={cn(fullPopupView ? style.containeFullBody  : style.conatinerBody)}>
                {children}
            </div>
        </div>
    )
}

export default Popup;